import React, {useMemo, useState} from 'react';
import {CheckboxDropdownItem} from '@zvne/fe-framework/dist/presentation/form/input/checkbox-dropdown-item';
import {DropdownControl} from '@zvne/fe-framework/dist/presentation/map/controls/dropdown-control';
import {useStrings} from '@zvne/fe-framework/dist/presentation/language/strings';
import {useTheme} from '@zvne/fe-framework/dist/presentation/theme/theme-context';
import {configuration} from '../../../../config/configuration';
import {Layer, Source} from 'react-mapbox-gl';
import {RasterSource} from 'mapbox-gl';
import {strings} from './strings';

interface Background {
    name: string,
    source: RasterSource
}

export function BackgroundLayer() {
    const theme = useTheme();
    const s = useStrings(strings);
    const backgrounds = useMemo<Background[]>(() => [
        {
            name: s.countryBorders,
            source: {
                type: 'raster',
                tiles: [
                    configuration.geoserverRoot +
                    '?bbox={bbox-epsg-3857}' +
                    '&format=image/png' +
                    '&service=WMS' +
                    '&version=1.1.1' +
                    '&request=GetMap' +
                    '&srs=EPSG:3857' +
                    '&transparent=true' +
                    '&width=256' +
                    '&height=256' +
                    `&styles=${theme === 'dark' ? 'countries-dark' : 'countries-light'}` +
                    `&layers=${configuration.geoserverLayerPrefix}:countries`
                ],
                tileSize: 256
            }
        },
        {
            name: s.openStreetMap,
            source: {
                type: 'raster',
                tiles: [
                    'https://b.tile.openstreetmap.org/{z}/{x}/{y}.png'
                ],
                tileSize: 256,
                attribution: '<a href="https://osm.org/copyright">&copy; OpenStreetMap</a>'
            }
        }
    ], [s, theme]);
    const [selectedIndex, setSelectedIndex] = useState(0);
    return (
        <>
            <DropdownControl id={'background'} title={s.background} order={10}>
                {backgrounds.map((background, index) =>
                    <CheckboxDropdownItem
                        key={index}
                        eventKey={`background-layer-${index}`}
                        value={index === selectedIndex}
                        onChange={checked => {
                            if (checked) {
                                setSelectedIndex(index);
                            }
                        }}
                    >
                        {background.name}
                    </CheckboxDropdownItem>
                )}
            </DropdownControl>
            <Source id={'background-source'} tileJsonSource={backgrounds[selectedIndex].source}/>
            <Layer type={'raster'} id={'background-layer'} sourceId={'background-source'}/>
        </>
    );
}
